<template>
    <div class="image-slider">
        <div :class=overlayStyle />
        <div
            class="slider-image"
            :style="`background-image: url(${curImage});`"
        />
    </div>
</template>

<script>

export default {
    name: 'ImageSlider',
    data: () => ({
        images: [
            '/pictures/splashs/0.jpg',
            '/pictures/splashs/1.jpg',
            '/pictures/splashs/2.jpg',
            '/pictures/splashs/3.jpg',
            '/pictures/splashs/4.jpg',
            '/pictures/splashs/5.jpg',
            '/pictures/splashs/6.jpg',
            '/pictures/splashs/7.jpg',
            '/pictures/splashs/8.jpg',
            '/pictures/splashs/9.jpg',
            '/pictures/splashs/10.jpg',
            '/pictures/splashs/11.jpg',
            '/pictures/splashs/12.jpg',
            '/pictures/splashs/13.jpg',
            '/pictures/splashs/14.jpg',
            '/pictures/splashs/15.jpg',
            '/pictures/splashs/16.jpg',
            '/pictures/splashs/17.jpg',
            '/pictures/splashs/18.jpg',
            '/pictures/splashs/19.jpg',
            '/pictures/splashs/20.jpg',
            '/pictures/splashs/21.jpg',
            '/pictures/splashs/22.jpg',
            '/pictures/splashs/23.jpg'
        ],
        curIndex: Math.round(Math.random() * 23),
        timer: null,
        overlayStyle: 'black-overlay'
    }),
    computed: {
        curImage () {
            return this.images[this.curIndex]
        }
    },
    methods: {
        startRotation () {
            this.timer = setInterval(this.nextSlide, 10000)
        },
        stopRotation () {
            clearTimeout(this.timer)
            this.timer = null
        },
        nextSlide () {
            this.overlayStyle = 'black-overlay overlay-animated'
            setTimeout(this.nextImage, 2000)
        },
        nextImage () {
            if (this.curIndex < this.images.length - 1) {
                this.curIndex++
            }
            else {
                this.curIndex = 0
            }
            setTimeout(this.stopAnim, 5000)
        },
        stopAnim () {
            this.overlayStyle = 'black-overlay'
        }
    },
    mounted () {
        this.startRotation()
    }
}
</script>

<style lang="stylus" scoped>
.image-slider {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;

    @keyframes slider-fadeIn {
        0% { opacity: .35; }
        50% { opacity: 1; }
        100% { opacity: .35; }
    }
    @keyframes slider-fadeOut {
        from { opacity: .35; }
        to { opacity: 1; }
    }

    .black-overlay {
        position: fixed;
        z-index: 10;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background: black;
        opacity: .35
    }
    .overlay-animated {
        animation: slider-fadeIn 4s ease;
    }

    .slider-image {
        position: fixed;
        z-index: 5;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
    }
}
</style>
